import PropTypes from 'prop-types'
import React from 'react'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--padding-md)',
    overflow: 'auto'
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 'var(--padding-md)'
  },
  image: {
    width: '150px',
    height: '150px',
    borderRadius: '50%',
    objectFit: 'cover',
    border: '3px solid var(--color-primary-400)'
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--padding-xs)',
    padding: 'var(--padding-sm)',
    borderRadius: 'var(--border-radius-md)',
    backgroundColor: 'var(--theme-color-surface-d1)'
  },
  label: {
    fontSize: 'var(--font-size-xs)',
    fontWeight: 600,
    color: 'var(--theme-color-on-surface-d0-muted)',
    textTransform: 'uppercase'
  },
  value: {
    fontSize: 'var(--font-size-md)',
    color: 'var(--theme-color-on-surface-d0)'
  }
})

export const PersonDetails = ({ entityProps }) => {
  const classes = useStyles()
  const person = entityProps?.data || {}

  // Helper to render a field if it has a value
  const renderField = (label, value) => {
    if (!value) return null
    return (
      <div className={classes.field}>
        <span className={classes.label}>{label}</span>
        <span className={classes.value}>{value}</span>
      </div>
    )
  }

  return (
    <div className={classes.container}>
      {person.profilePic && (
        <div className={classes.imageContainer}>
          <img src={person.profilePic} alt={person.label} className={classes.image} />
        </div>
      )}

      {renderField('Name', person.label)}
      {renderField('Birth Date', person.birthDate)}
      {renderField('Death Date', person.deathDate)}
      {renderField('Person Type', person.personType?.name)}
      {renderField('Relationship', person.relationship)}
      {renderField('Notes', person.notes)}

      {/* Add any additional fields from the person data */}
      {Object.entries(person).map(([key, value]) => {
        // Skip already rendered fields and system fields
        const skipFields = ['label', 'birthDate', 'deathDate', 'personType', 'relationship', 'notes', 'profilePic', 'levelId', 'levelTypeId', 'familyTreeDepth']
        if (skipFields.includes(key) || !value || typeof value === 'object') return null

        // Format the key to be human readable
        const formattedKey = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())
        return renderField(formattedKey, value)
      })}
    </div>
  )
}

PersonDetails.propTypes = {
  entityProps: PropTypes.shape({
    data: PropTypes.object
  })
}
